import { render, staticRenderFns } from "./BeforeTrans.vue?vue&type=template&id=6dcd684f&scoped=true&"
import script from "./BeforeTrans.vue?vue&type=script&lang=js&"
export * from "./BeforeTrans.vue?vue&type=script&lang=js&"
import style0 from "./BeforeTrans.vue?vue&type=style&index=0&id=6dcd684f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcd684f",
  null
  
)

export default component.exports